
const codeGenMetadata: any = {
  formPropertyId: 10,
  formSelector: '[data-name*="refi-consentimento-formulario"]',
  subjectIdentifiers: [
    {
      name: "Nome Completo",
      selector: ".refi-consentimento-nome",
      isPrimary: false,
    },
    {
      name: "Email",
      selector: ".refi-consentimento-email",
      isPrimary: false,
    },
    { name: "CPF", selector: ".refi-consentimento-cpf", isPrimary: true },
    {
      name: "Data Nascimento",
      selector: ".refi-consentimento-dt-nascimento",
      isPrimary: false,
    },
    {
      name: "Celular",
      selector: ".refi-consentimento-telefone",
      isPrimary: false,
    },
  ],
  consentIdentifiers: [
    {
      type: "checkbox",
      name: "Contato Whatsapp",
      selector: ".refi-consentimento-acceptWhatsapp",
      propertyId: 30,
      consentValue: "checked",
    },
    {
      type: "checkbox",
      name: "Termos de Uso",
      selector: ".refi-consentimento-agreeTerms",
      propertyId: 31,
      consentValue: "checked",
    },
  ],
  consentTrigger: {
    action: "click",
    selector: ".refi-consentimento-continuar",
  },
}

export default codeGenMetadata;